import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ArticlePage from "../pages/article/page";
import Layout from "../components/Layout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: ":lang",
        element: <HomePage />,
      },
      {
        path: ":lang/products",
        element: <ProductsPage />,
      },
      {
        path: ":lang/allchinabuy-spreadsheet",
        element: <ArticlePage articleId="spreadsheet" />,
      },
      {
        path: ":lang/allchinabuy-review",
        element: <ArticlePage articleId="review" />,
      },
      {
        path: ":lang/allchinabuy-shipping",
        element: <ArticlePage articleId="shipping" />,
      },
      {
        path: ":lang/allchinabuy-coupon",
        element: <ArticlePage articleId="coupon" />,
      },
      {
        path: ":lang/allchinabuy-warehouse",
        element: <ArticlePage articleId="warehouse" />,
      },
      {
        path: ":lang/allchinabuy-qc",
        element: <ArticlePage articleId="qc" />,
      },
      {
        path: ":lang/allchinabuy-safety",
        element: <ArticlePage articleId="safety" />,
      },
      {
        path: ":lang/allchinabuy-finds",
        element: <ArticlePage articleId="finds" />,
      },
      {
        path: ":lang/allchinabuy-products",
        element: <ArticlePage articleId="products" />,
      },
      {
        path: ":lang/allchinabuy-alternatives",
        element: <ArticlePage articleId="alternatives" />,
      },
      {
        path: ":lang/allchinabuy-vs-superbuy",
        element: <ArticlePage articleId="vs-superbuy" />,
      },
      {
        path: ":lang/allchinabuy-vs-sugargoo",
        element: <ArticlePage articleId="vs-sugargoo" />,
      },
      {
        path: ":lang/allchinabuy-vs-pandabuy",
        element: <ArticlePage articleId="vs-pandabuy" />,
      },
      {
        path: ":lang/allchinabuy-comparison",
        element: <ArticlePage articleId="comparison" />,
      },
      {
        path: ":lang/allchinabuy-spreadsheet-guide",
        element: <ArticlePage articleId="spreadsheet-guide" />,
      },
      {
        path: ":lang/allchinabuy-how-to-order",
        element: <ArticlePage articleId="how-to-order" />,
      },
      {
        path: ":lang/allchinabuy-beginner-guide",
        element: <ArticlePage articleId="beginner-guide" />,
      },
      {
        path: ":lang/allchinabuy-faq",
        element: <ArticlePage articleId="faq" />,
      },
      {
        path: ":lang/about",
        element: <ArticlePage articleId="about" />,
      },
      {
        path: ":lang/contact",
        element: <ArticlePage articleId="contact" />,
      },
      {
        path: ":lang/privacy",
        element: <ArticlePage articleId="privacy" />,
      },
      {
        path: ":lang/terms",
        element: <ArticlePage articleId="terms" />,
      },
      {
        path: ":lang/faq",
        element: <ArticlePage articleId="faq" />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;